import React from 'react'

const AuthTokenContext = React.createContext(null)
export default AuthTokenContext
